(function () {
  function initWorkshopFaq(root) {
    if (root.dataset.wfReady === 'true') return;
    root.dataset.wfReady = 'true';

    var singleCategory = root.dataset.singleCategory === 'true';
    var singleQuestion = root.dataset.singleQuestion === 'true';

    root.querySelectorAll('[data-wf-category]').forEach(function (category) {
      category.addEventListener('toggle', function () {
        if (!singleCategory || !category.open) return;
        root.querySelectorAll('[data-wf-category]').forEach(function (other) {
          if (other !== category) other.open = false;
        });
      });
    });

    root.querySelectorAll('[data-wf-questions]').forEach(function (group) {
      group.querySelectorAll('[data-wf-question]').forEach(function (question) {
        question.addEventListener('toggle', function () {
          if (!singleQuestion || !question.open) return;
          group.querySelectorAll('[data-wf-question]').forEach(function (other) {
            if (other !== question) other.open = false;
          });
        });
      });
    });
  }

  function boot() {
    document.querySelectorAll('[data-workshop-faq]').forEach(initWorkshopFaq);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-workshop-faq]');
    if (root) initWorkshopFaq(root);
  });
})();
